// in powershell
// cd "C:\Users\Michel Quak\source\VSrepos\OrangeButtonModelMaker"
// .\.venv\Scripts\Activate
// uvicorn predict_api:app --reload


export async function getPredictedValue(parameters, obparam, filetype) {

    const body = {
    parameters: parameters,
    obparam: obparam,
    filetype: filetype
    };

    // console.log(JSON.stringify({
    //         parameters: parameters,
    //         obparam: obparam,
    //         filetype: filetype}))

    const response = await fetch('http://127.0.0.1:8000/find_best_parameter_value', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        // body: JSON.stringify(
        //     parameters, obparam, filetype

        // )
            body: JSON.stringify({parameters: {
            parameters: parameters},
            obparam: obparam,
            filetype: filetype

        })
    });

    if (!response.ok) {
        console.error("Prediction API error:", response.status, await response.text());
        return null;
    }

    return await response.json();
}

